import { useHistory } from "react-router-dom";
import { Card } from "../../../components/card.component";
import { AppRouteUi } from "../../../config/appRoute";
import { InvoiceCards } from "../../../features/invoice/invoiceCards.component";
import { useEffect, useState } from "react";
import {
  ApiSchemaInvoice,
  ApiSchemaTaskDate,
} from "../../../models/api/invoice";
import { useParams } from "react-router";
import { UtilityDate } from "../../../utils/dateUtils";
import { ApiInvoice } from "../../../core/apis/invoice";
import { showErrorToast } from "../../../components/toast.component";

export const PageSingleInvoice = () => {
  const history = useHistory<ApiSchemaInvoice>();
  const { invoiceId } = useParams<{ invoiceId: string }>();
  const [invoice, setInvoice] = useState<ApiSchemaInvoice>();
  const [invoiceTasks, setInvoiceTasks] = useState<ApiSchemaTaskDate[]>([]);

  useEffect(() => {
    if (!history.location.state || history.location.state.sKey !== invoiceId)
      history.replace(AppRouteUi.Invoice.List());
    setInvoice(history.location.state);
  }, [history, invoiceId]);

  useEffect(() => {
    const getInvoiceTask = async () => {
      const response = await ApiInvoice.GetTask(invoiceId)!;
      if (response?.isSuccess) {
        setInvoiceTasks(response.data!);
      } else {
        response && showErrorToast({ message: response?.message });
      }
    };

    getInvoiceTask();
  }, [invoiceId]);

  return (
    <Card
      header={
        <div className="row align-items-center justify-content-between">
          <div className="col content-box-title">
            <div className="d-flex align-items-center">
              <div
                onClick={() => {
                  history.push(AppRouteUi.Invoice.List());
                }}
                className="pe-2 border-2 border-end click text-green-200"
              >
                <i className="fas fa-arrow-left text-green-200" />
              </div>
              <p className="text-capitalize mb-0 ps-2  text-green-200">
                {invoice?.invoiceNumber}
              </p>
            </div>
            <div className="collapse-icon"></div>
          </div>
        </div>
      }
    >
      <div className="p-2">
        <div className="mb-3 row">
          <div className="col-md-6 col-sm-6 col-12">
            <p>
              <b>Patient's Name:</b>{" "}
              {invoice?.patientFirstName + " " + invoice?.patientLastName}
            </p>
          </div>
          <div className="col-md-6 col-sm-6 col-12">
            <p>
              <b>Care giver's Name:</b>{" "}
              {invoice?.caregiverFirstName + " " + invoice?.caregiverLastName}
            </p>
          </div>
        </div>
        <div className="mb-3 row">
          <div className="col-md-6 col-sm-6 col-12">
            <p>
              <b>Start Date:</b>{" "}
              {UtilityDate.formatDate(
                new Date(invoice?.startDate || new Date())
              )}
            </p>
          </div>
          <div className="col-md-6 col-sm-6 col-12">
            <p>
              <b>End Date:</b>{" "}
              {UtilityDate.formatDate(new Date(invoice?.endDate || new Date()))}
            </p>
          </div>
        </div>
        <div className="mb-2">
          <p>
            <b>Task Dates</b>
          </p>
          <InvoiceCards invoices={invoiceTasks} />
        </div>
      </div>
    </Card>
  );
};
